import { UserActions } from '@chegg/commerce-utils';
import { ComponentOneClickResubscribeModal, CurrencyCode, ProductInfo } from '@chegg/rio-event-schema-web';
import { sendEventRio2 } from '@chegg/commerce-utils';
export var R2wcEvent = /*#__PURE__*/function (R2wcEvent) {
  R2wcEvent["COMPONENT_ONE_CLICK_RESUBSCRIBE"] = "com.chegg.rio.conversion.ComponentOneClickResubscribe";
  return R2wcEvent;
}({});
/**
 * Rio2.0 Resubscribe event
 * @param action
 * @param productData
 */
export var sendResubscribeRio2Event = function sendResubscribeRio2Event(action, productData) {
  var data = new ComponentOneClickResubscribeModal.ComponentOneClickResubscribe().setProductsList([new ProductInfo.ProductInfo().setProductId(productData.product_id).setQuantity(productData.quantity).setProductTypeClient(productData.product_type || '').setProductType(productData.product_type).setDisplayPrice(productData.display_price)]).setCurrencyCode(CurrencyCode.CurrencyCode[productData.currency_code]);
  action === UserActions.RESUBSCRIBE && sendEventRio2({
    eventType: R2wcEvent.COMPONENT_ONE_CLICK_RESUBSCRIBE,
    eventData: data
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/RioEvents.js
// module id = 4199
// module chunks = 11